
export const STATUS = {
    default : 'default',
    warning : 'warning',
    processing : 'processing',
    success : 'success',
    error : 'error'
}

export const AD_STATUS = {
    draft : 'draft',
    pending : 'pending',
    active : 'active',
    paused : 'paused',
    terminated : 'terminated'
}

export function getAdStatus(status){

    switch(status){
        case AD_STATUS.draft: 
            return STATUS.default
        case AD_STATUS.pending:
            return STATUS.processing
        case AD_STATUS.active:
            return STATUS.success
        case AD_STATUS.paused:
            return STATUS.warning
        case AD_STATUS.terminated:
            return STATUS.error
    }

}


// WEBPACK FOOTER //
// ./src/components/eezee-ads/table/ad-status.js